export default {"src":"/_next/static/media/0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};